class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.timeouts = new Map();
    this.timeout = null;
    this.addEventListener('keyup', this.onKeyUp);
    this.mainDetailsToggle = this.querySelector('details');
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('mouseenter', this.onHover.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onExitHover.bind(this));
    this.mainDetailsToggle.addEventListener('touchstart', this.onHover.bind(this));

    this.mainDetailsToggleHeader = this.querySelector(".main-details");
    if (this.mainDetailsToggleHeader) {
      this.mainDetailsSummaryHeader = this.mainDetailsToggleHeader.querySelector("summary");
    }

    if (this.mainDetailsToggleHeader) {
      this.mainDetailsSummaryHeader.addEventListener('click', (event) => {
        const detailHref = this.mainDetailsToggleHeader.dataset.href;
        if (detailHref && event.detail !== 0) {
          event.preventDefault();
          const isAbove1024 = window.matchMedia('(min-width: 1025px)').matches;
          if (detailHref && event.detail !== 0 && isAbove1024) {
            location.href = detailHref;
          }
        }
      });
    }  
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onHover(event) {
    event.preventDefault();
    const isTouch = event.type === 'touchstart';
    const isHoveredOrTouched = isTouch ? true : event.target.matches(':hover');

    if (isHoveredOrTouched && event.target) {
      if(this.timeouts.has(event.target)) {
        clearTimeout(this.timeouts.get(event.target));
      }

      let timeout = setTimeout(function () {
          this.timeouts.delete(event.target);
          this.open(event);
      }.bind(this), 300);

      this.timeouts.set(event.target, timeout);
    }
  }

  onExitHover(event) {
    event.preventDefault();
    if(event.target && this.timeouts.has(event.target)) {
      clearTimeout(this.timeouts.get(event.target));
    }
  }

  onMenuClose(event) {
    if (!this.contains(event.target)) this.close(false);
  }

  open(event) {
    event.target.closest('nav').querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
    });

    this.onMenuCloseEvent =
      this.onMenuCloseEvent || this.onMenuClose.bind(this);
    this.mainDetailsToggle.setAttribute('open', true);
    document.body.addEventListener('click', this.onMenuCloseEvent);
    document.body.addEventListener('mouseover', this.onMenuCloseEvent);

    trapFocus(
      this.mainDetailsToggle.querySelector('.header__submenu-contents')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.mainDetailsToggle : null);
    this.mainDetailsToggle.removeAttribute('open');
    document.body.removeEventListener('click', this.onMenuCloseEvent);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
